import { Component, OnInit, Input, Output, EventEmitter, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-modal-basic',
  templateUrl: './modal-basic.component.html',
  styleUrls: ['./modal-basic.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalBasicComponent implements OnInit, OnDestroy {
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() fitBody = false;
  @Input() hideFooter = false;
  @Input() hideOnContainerClicked = false;
  @Output() hidden = new EventEmitter<boolean>();
  @Output() shown = new EventEmitter<boolean>();

  visible = false;
  visibleAnimate = false;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnDestroy(): void {
    this.hide();
  }

  ngOnInit() {}

  show(): void {
    this.visible = true;
    this.shown.emit();
    setTimeout(() => (this.visibleAnimate = true), 100);
    this.document.body.classList.add('modal-open');
  }

  hide(): void {
    this.visibleAnimate = false;
    this.hidden.emit();
    setTimeout(() => (this.visible = false), 300);
    this.document.body.classList.remove('modal-open');
  }

  onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal') && this.hideOnContainerClicked) {
      this.hide();
    }
  }
}
